const ArrowDown = ({ width = 24, height = 24, color = "#111" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      color={color}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="m6 9 6 6 6-6" />
    </svg>
  );
};

export default ArrowDown;
